var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full"},[_c('div',{class:_vm.config.isDetailDisplay ? 'small-list' : 'scroll-auto'},[_c('Control',{attrs:{"config":_vm.config},on:{"onChangeEditDataSource":_vm.onChangeEditDataSource}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }